import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

import * as _ from 'lodash';
import * as domtoimage from 'dom-to-image';
import * as dot from 'dot-object';
declare var $:any;

@Component({
	selector: 'app-proposal',
	templateUrl: './proposal.component.html',
	styleUrls: ['./proposal.component.css']
})
export class ProposalComponent implements OnInit {
	filter_proposal = {};
	data_proposal;
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		this.loadProposal();
	}
	ngAfterViewChecked() {
		$('.text-justify img').addClass('img-fluid');
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}
	goTab(el) {
		$(`a[href="${el}"]`)[0].click();
	}

	loadProposal(param = null, add = false) {
		let filter = this.filter_proposal;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "accountcode": this.appServices.accountcode})
		this.appServices.api('Crmproposals/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_proposal.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_proposal.res = obj.component.data_proposal.res.concat(json.res);
			} else {
				obj.component.data_proposal = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doMore() {
		this.loadProposal(this.filter_proposal, true);
	}
	updateProposal(frm, attr, size) {
		frm[attr] = Array(frm[size]).fill({}).map((el, indx) => {
			return {name: `block${indx}`}
		});
	}
	saveProposal(data) {
		dot.object(data)
		data = _.pickBy(data)
		data['accountcode'] = this.appServices.accountcode;
		data['deleted'] = false
		data['content'] = Object.keys(data['content']).map(key => {
			return {'name': key, [key]:data['content'][key]}
		})
		this.appServices.api('Crmproposals/save', data, this).then(function(obj){
			let json = obj.response.json();
			obj.component.notifyService.show(obj.response.statusText)
			obj.component.loadProposal();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	sendProposal(data) {
		domtoimage.toPng(document.getElementById('print-template')).then((base64) => {
			this.appServices.api('Contacts/sendmail', {
				'to': [data.email],
				'cc': [data.cc],
				'subject': data.subject,
				'content': `<img src="cid:bg">`,
				'files': [{
					"cid":"bg",
					"path": base64
				}]
			}, this).then(function(obj){
				let res = obj.response.json().res;
				obj.component.notifyService.show(obj.response.statusText)
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		}).catch(function (err) {
			console.log(err)
		});
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/proposal/proposal.component.ts